'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { existingUserSteps, tours } from 'DesignData/constants/Onboarding';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import { EERIE } from 'HubStyleTokens/colors';

const i18nKey = key => `designManager.onboarding.existingUser.showFinderStep.${key}`;

class ExistingUserShowFinderStep extends Component {
  renderContent() {
    return /*#__PURE__*/_jsxs("div", {
      className: "onboarding-popover-content",
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('header')
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('body')
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('subtext')
        })
      }), /*#__PURE__*/_jsx(UITourNextButton, {
        use: "primary",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('button')
        })
      })]
    });
  }

  renderHeader() {
    return /*#__PURE__*/_jsx(UICloseButton, {
      color: EERIE,
      onClick: this.context.tour.finish,
      size: "medium"
    });
  }

  render() {
    return /*#__PURE__*/_jsx(UITourStep, {
      tourKey: tours.EXISTING_USER_IDE,
      stepKey: existingUserSteps.SHOW_FINDER_STEP,
      className: "finder-onboarding-tooltip",
      content: {
        header: this.renderHeader(),
        body: this.renderContent()
      },
      placement: "right",
      width: 250,
      closeOnOutsideClick: false,
      children: this.props.children
    });
  }

}

ExistingUserShowFinderStep.propTypes = {
  children: PropTypes.node
};
ExistingUserShowFinderStep.contextType = TourContext;
ExistingUserShowFinderStep.defaultProps = {
  children: /*#__PURE__*/_jsx("div", {})
};
export default ExistingUserShowFinderStep;